import { ConfigProvider, Select } from 'antd'
import React from 'react'

import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Switch from '@ui-pc/Switch'
import Text from '@ui-pc/Text'
import { Knife, Type } from '@utils/tool'

import { ctx } from '../../utils'
import { Content } from './components/Comment'
import { ReviewPhotos } from './components/ReviewPhotos'
import winPixel from '@api/hernest/winPixel_m.bak'

export function IndexV2(props: { children? }) {
  const { children } = props
  const [state, setState] = ctx.useState()

  const ref = ctx.useRef()

  const { reviewNum } = state

  const itemsRating = [
    { value: 0, label: 'All Stars' },
    ...Knife.newArray(5, (index) => ({ value: 5 - index }))
  ].map((data: any) => {
    return {
      value: data.value,
      label: (
        <span className="dropdown-item" onClick={() => {}}>
          <span>{data.label || `${data.value} Star Only`} </span>
          {/* <Rate style={{ fontSize: 16 }} disabled value={data} /> */}
        </span>
      )
    }
  })

  const selects = [
    {
      defaultValue: 'Recommend',
      options: [
        {
          value: 1,
          label: 'Recommend'
        },
        {
          value: 2,
          label: 'Most Recent'
        }
      ],
      onChange(value) {
        ref.current.onOrderFilter(value)
      }
    },
    {
      value: state.selectValue,
      defaultValue: 'All Stars',
      options: itemsRating,
      onChange(value) {
        ref.current.onRatingFilter(value)
      }
    },
    {
      defaultValue: 'Images & Videos',
      options: [
        {
          value: 'Images & Videos',
          label: 'With Images & Videos'
        }
      ],
      onChange(value) {
        ref.current.onMediaFilter(1)
      }
    }
  ]

  return (
    <ConfigProvider
      theme={{
        token: {
          // motionDurationMid: '0s',
          // motionDurationSlow: '0s'
        },
        components: {
          Pagination: {
            // itemActiveBg: '#157E6F'
          },
          Progress: {
            lineBorderRadius: 10
          }
        }
      }}>
      <Switch either={Type.number(reviewNum) > 0}>
        <>
          <ReviewPhotos />
          <Flex className="select-area">
            {selects.map((data: any) => {
              return (
                <Select
                  {...data}
                  className="select"
                  style={{ width: 'auto' }}
                  suffixIcon={<Icon customSrc="icon-lower" className="icon" />}
                  onSelect={(value) => {
                    winPixel.viewSection(
                      'Detail',
                      `Reviews-${data?.defaultValue}-${value}`,
                      null,
                      null,
                      '0',
                      '1',
                      {}
                    )
                  }}
                />
              )
            })}
          </Flex>
          {children ? children : <Content />}
        </>
      </Switch>
    </ConfigProvider>
  )
}

export default IndexV2
